<template>
    <div>
        <div class="video-presentation-area ptb-100">
            <div class="container">
                <div class="section-title" data-aos="fade-up">
                    <h2>Warum uns wählen - sehen Sie selbst</h2>
                </div>

                <div data-aos="fade-up" data-aos-delay="100">
                    <Funfacts />
                </div>

                <div class="contact-cta-box mwidth-1000" data-aos="fade-up" data-aos-delay="200">
                    <h3>Haben Sie Fragen an uns?</h3>
                    <p>Zögern Sie nicht, uns zu kontaktieren.</p>
                    <router-link to="/contact" class="default-btn">
                        <i class="bx bxs-edit-alt"></i>
                        Kontakt aufnehmen
                        <span></span>
                    </router-link>
                </div>
            </div>

            <div class="shape-map1"><img src="../../assets/img/map1.png" alt="image"></div>
            <div class="shape7"><img src="../../assets/img/shape/7.png" alt="image"></div>
            <div class="shape8"><img src="../../assets/img/shape/8.png" alt="image"></div>
            <div class="shape9"><img src="../../assets/img/shape/9.png" alt="image"></div>
        </div>
        <div 
            class="popup-video" 
            v-if="isPopup"
        >
            <div class="d-table">
                <div class="d-table-cell">
                    <div 
                        class="popup-overlay-close"
                        v-on:click="isPopupMethod(isPopup)"
                    >
                        <div class="popup-overlay-close-line"></div>
                        <div class="popup-overlay-close-line"></div>
                    </div>
                    <div class="play-video">
                        <iframe src="https://www.youtube.com/embed/bk7McNUjWgw"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Funfacts from './Funfacts';

export default {
    name: 'WhyChooseUs',
    components: {
        Funfacts,
    },
    data (){
        return {
            isPopup: false,
        }
    },
    methods: {
        isPopupMethod(isPopup){
            return this.isPopup = !isPopup
        },
    },
}
</script>